import Container from './Container';
import Points from '@/client/components/Tournaments/LeaderboardItem/Points';
import Position from '@/client/components/Tournaments/LeaderboardItem/Position';
import Username from '@/client/components/Tournaments/LeaderboardItem/Username';

type Props = {
  position?: number;
  isMyScore?: boolean;
  username?: string;
  points?: string;
  translations: Record<string, string>;
  isBitcasino: boolean;
};

const LeaderboardItem: FC<Props> = ({
  username,
  isMyScore,
  points,
  position,
  translations,
  isBitcasino,
}) => (
  <Container isMyScore={isMyScore}>
    <Position
      size="Small"
      position={position}
      isMyScore={isMyScore}
      isBitcasino={isBitcasino}
    />
    <Username
      translations={translations}
      position={position}
      username={username}
      isMyScore={isMyScore}
    />
    <Points position={position} points={points} center={false} />
  </Container>
);

export default LeaderboardItem;
